import commonApi from '@/api/_common.js'
import axios from 'axios'
import CONF from '@/config.js'

// Helper function to format date from YYYY-MM-DD to YYYYMMDD
const formatDate = (date) => {
    if (!date || !date.includes('-') || date.length !== 10) return date
    return date.replace(/-/g, '')
}

// Helper function to extract common parameters
const extractParams = (param) => ({
    searchStart: formatDate(param?.search_start ?? ''),
    searchEnd: formatDate(param?.search_end ?? ''),
    pageNo: param?.page_no ?? 1,
    pageSize: param?.page_size ?? 20,
    answerYn: param?.answer_yn ?? '',
    searchType: param?.search_type ?? '',
    searchText: param?.search_text ?? ''
})

export default {
    getCallbackList(param, scb, fcb, va) {
        const { searchStart, searchEnd, pageNo, pageSize, answerYn, searchType, searchText } = extractParams(param)

        const params = new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            page_no: pageNo,
            page_size: pageSize,
            answer_yn: answerYn,
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })
        const reqURL = `/svc_hist/callback_list?${params}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.callback_list, data.total_count, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getCallbackList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },


    getRecvCallList(param, scb, fcb) {
        const { searchStart, searchEnd, pageNo, pageSize } = extractParams(param)
        
        const params = new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            page_no: pageNo,
            page_size: pageSize,
            call_type: 'INB_RECV'
        })
        const reqURL = `/svc_hist/call_list?${params}`
        
        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.call_list, data.total_count, data.total_page_count, data.page_no)
            }
        }, (err) => {
            console.log('api.svc_hist.getRecvCallList : FAIL : ', err)
            if (fcb) {
                fcb(err)
            }
        })
    },

    getSendCallList(param, scb, fcb, va) {
        const { searchStart, searchEnd, pageNo, pageSize, searchType, searchText } = extractParams(param)
        const callResult = param?.call_result ?? ''
        
        const params = new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            page_no: pageNo,
            page_size: pageSize,
            call_type: 'OTB_SEND',
            ...(callResult && { call_result: callResult }),
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })
        const reqURL = `/svc_hist/call_list?${params}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.call_list, data.total_count, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getRecvCallList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        })
    },


    getSvcList(param, scb, fcb, va) {
        const { searchStart, searchEnd, pageNo, pageSize, searchType, searchText } = extractParams(param)
        const transResult = param?.trans_result ?? ''
        
        const params = new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            page_no: pageNo,
            page_size: pageSize,
            ...(transResult && { trans_result: transResult }),
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })
        const reqURL = `/svc_hist/svc_list?${params}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.svc_list, data.total_count, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getSvcList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        })
    },


    getSvcCallList(param, scb, fcb, va) {
        const callSid = param?.call_sid ?? ''
        const reqURL = `/svc_hist/svc_call_list?${new URLSearchParams({ call_sid: callSid })}`
        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.call_list, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getSvcCallList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        })
    },

    downloadRecord: function (param, fcb) {
        const seq = param?.seq ?? 0
        const tm = param?.tm?.substring(0, 12) ?? ''
        const mdn = param?.mdn ?? ''
        
        const fileName = ['record', tm, mdn, seq].filter(Boolean).join('_') + '.mp3'

        axios({
            url: CONF.API_BASE_URL + '/svc_hist/download_record/' + seq,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            // Check if response is JSON error
            if (response.data.type === 'application/json') {
                response.data.text().then(text => {
                    const errorData = JSON.parse(text)
                    if (fcb) {
                        fcb(errorData?.result_desc)
                    }
                })
                return
            }

            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
        })
    },

    downloadExcel: function (param, scb, fcb, va) {
        const { searchStart, searchEnd } = extractParams(param)
        const callType = param?.call_type ?? 'INB_RECV'
        const timestamp = Date.now()
        
        const reqURL = `${CONF.API_BASE_URL}/svc_hist/call_list/excel?${new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            call_type: callType,
            tm: timestamp
        })}`

        axios({
            url: reqURL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'call_' + callType + '_' + timestamp + '.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();

            if (scb) {
                scb(va)
            }
        }).catch((err) => {
            console.log('axios fail :', err);
            if (fcb) {
                fcb(err, va)
            }
        });
    },


    downloadSvcExcel: function (param, scb, fcb, va) {
        const { searchStart, searchEnd, searchType, searchText } = extractParams(param)
        const transResult = param?.trans_result ?? ''
        const timestamp = Date.now()
        
        const reqURL = `${CONF.API_BASE_URL}/svc_hist/svc_list/excel?${new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            tm: timestamp,
            ...(transResult && { trans_result: transResult }),
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })}`

        axios({
            url: reqURL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'svc_call_' + timestamp + '.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();

            if (scb) {
                scb(va)
            }
        }).catch((err) => {
            console.log('axios fail :', err);
            if (fcb) {
                fcb(err, va)
            }
        });
    },


    downloadMemoExcel: function (param, scb, fcb, va) {
        const { searchType, searchText } = extractParams(param)
        const timestamp = Date.now()
        
        const reqURL = `${CONF.API_BASE_URL}/svc_hist/cust_memo_group_list/excel?${new URLSearchParams({
            tm: timestamp,
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })}`

        axios({
            url: reqURL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'memo_' + timestamp + '.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();

            if (scb) {
                scb(va)
            }
        }).catch((err) => {
            console.log('axios fail :', err);
            if (fcb) {
                fcb(err, va)
            }
        });
    },

    downloadCallbackExcel: function (param, scb, fcb, va) {
        const { searchStart, searchEnd, answerYn, searchType, searchText } = extractParams(param)
        const timestamp = Date.now()
        
        const reqURL = `${CONF.API_BASE_URL}/svc_hist/callback_list/excel?${new URLSearchParams({
            search_start_date: searchStart,
            search_end_date: searchEnd,
            tm: timestamp,
            ...(answerYn && { answer_yn: answerYn }),
            ...(searchType && searchText && { search_type: searchType, search_text: searchText })
        })}`

        axios({
            url: reqURL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'callback_' + timestamp + '.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();

            if (scb) {
                scb(va)
            }
        }).catch((err) => {
            console.log('axios fail :', err);
            if (fcb) {
                fcb(err, va)
            }
        });
    },

    getCustMemoGroupList(param, scb, fcb, va) {
        const {pageNo, pageSize, searchType, searchText} = extractParams(param)
        const reqURL = `/svc_hist/cust_memo_group_list?${new URLSearchParams({
            page_no: pageNo,
            page_size: pageSize,
            ...(searchType && searchText && {search_type: searchType, search_text: searchText})
        })}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.cust_memo_group_list, data.total_count, data.page_no, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getCustMemoGroupList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    getCustMemoList(param, scb, fcb, va) {
        const {pageNo, pageSize} = extractParams(param)
        const memoText = param?.memo_text ?? ''
        const reqURL = `/svc_hist/cust_memo_list?${new URLSearchParams({
            page_no: pageNo,
            page_size: pageSize,
            cust_seqno: param.cust_seqno,
            ...(memoText && {memo_text: memoText})
        })}`

        commonApi.GET(reqURL, (data) => {
            if (scb) {
                scb(data.cust_memo_list, data.cust_memo_group, data.total_count, data.page_no, va)
            }
        }, (err) => {
            console.log('api.svc_hist.getCustMemoList : FAIL : ', err)
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    },

    createCustMemo(param, scb, fcb, va) {
        let url = '/svc_hist/cust_memo_create'

        commonApi.POST(url, param, data => {
            if (scb) {
                scb(data.cust_seqno, va)
            }
        }, err => {
            if (fcb) {
                fcb(err, va)
            }
        }, va)
    }
}